import { gql } from "@edreamsodigeo/frontend-api-client";

const USER_FRAGMENT = gql`
  fragment UserParts on User {
    id
    displayName
    email
    membership {
      status
      name
      lastNames
      partner
    }
  }
`;

export default USER_FRAGMENT;
